module.exports = __webpack_public_path__ + "static/media/fertiberia-tech-gray.d19202b5.png";